require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-campaign-environment-climate.json") })
        }
      }, "path---en-us-campaign-environment-climate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-campaign-environment-climate!./.cache/json/en-us-campaign-environment-climate.json
// module id = 471
// module chunks = 231608221292675